<fieldset>
  <div class="form-group" [class.row]="!detailViewComponent.smallScreen">
    <label
      class="col-form-label"
      [class.col-4]="!detailViewComponent.smallScreen"
      [class.text-right]="!detailViewComponent.smallScreen"
      [class.required]="prop.field_required"
    >
      {{ prop.field_label | translate }}
    </label>
    <div [class.col-8]="!detailViewComponent.smallScreen" class="detail-view-checkbox">
      <div class="form-check">
        <div class="pretty p-switch p-slim">
          <input
            class="form-check-input"
            type="checkbox"
            [name]="prop.field_name"
            [id]="prop.field_id"
            [formControl]="graphicFormGroup.controls[prop.field_name]"
          />
          <div class="state p-success">
            <label></label>
          </div>
          <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
        </div>
      </div>
    </div>
  </div>
</fieldset>
